import React from 'react';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';
import { PropertyOption } from '@/api/types/categories.types';
import { Collection } from '@/components/Filters/FiltersDrawer.types';
import { CheckboxSize } from '@/components/UI/Checkbox/Checkbox.types';

type Props = {
  option: PropertyOption;
  collection?: Collection;
  onOptionSelect: (option: PropertyOption) => void;
  highlightLabel?: boolean;
  size?: CheckboxSize;
};

export const CollectionSelectOption = ({
  option,
  collection,
  onOptionSelect,
  highlightLabel,
  size = 'lg',
}: Props) => {
  const isChecked =
    option.legacyResourceId.toString() ===
    collection?.[option.propertyLegacyId];

  return (
    <Checkbox
      onChangeHook={() => onOptionSelect(option)}
      key={option.name}
      value={isChecked}
      label={option.name}
      appearance="radio"
      size={size}
      highlightLabel={highlightLabel}
      dataTestId={`property-option-${option.legacyResourceId}`}
    />
  );
};
